import { mergeStyles } from '../../../../internal/utils/mergeStyles';
import mainStyles from './styles.module.css';
import groupStyles from './group.module.css';
export const getStyles = size => mergeStyles(mainStyles, groupStyles, require("./size/".concat(size, ".module.css")));